__turbopack_context__.v({
  "container": "wh40Pa_container",
  "copyCell": "wh40Pa_copyCell",
  "copyIcon": "wh40Pa_copyIcon",
  "counter": "wh40Pa_counter",
  "empty": "wh40Pa_empty",
  "pageBtn": "wh40Pa_pageBtn",
  "pageInfo": "wh40Pa_pageInfo",
  "pagination": "wh40Pa_pagination",
  "searchInput": "wh40Pa_searchInput",
  "sortArrow": "wh40Pa_sortArrow",
  "sortable": "wh40Pa_sortable",
  "table": "wh40Pa_table",
  "tableWrapper": "wh40Pa_tableWrapper",
  "toolbar": "wh40Pa_toolbar",
});
